export enum EmailType {
  PasswordReset = 'PASSWORD_RESET',
  UserRegistration = 'USER_REGISTRATION',
  TransferCompanyInvoice = 'TRANSFER_COMPANY_INVOICE',
  PartnerInvoice = 'PARTNER_INVOICE',
  PreferredOffering = 'PREFERRED_OFFERING',
  GenericOffering = 'GENERIC_OFFERING',
  JourneyRejected = 'JOURNEY_REJECTED',
  JourneyCancelled = 'JOURNEY_CANCELLED',
  BookerBookingPlaced = 'BOOKER_BOOKING_PLACED',
  BookerJourneyConfirmed = 'BOOKER_JOURNEY_CONFIRMED',
  TravellerJourneyPlanned = 'TRAVELLER_JOURNEY_PLANNED',
  TransferCompanyAcceptedJourney = 'TRANSFER_COMPANY_ACCEPTED_JOURNEY',
  PendingJourneyDestinationManagerReminder = 'PENDING_JOURNEY_DESTINATION_MANAGER_REMINDER',
  CompletedJourneyTravellerSurvey = 'COMPLETED_JOURNEY_TRAVELLER_SURVEY',
}

export const EmailTypeDisplayName = {
  [EmailType.PasswordReset]: "Password Reset",
  [EmailType.UserRegistration]: "User Registration",
  [EmailType.TransferCompanyInvoice]: "Transfer Company Invoice",
  [EmailType.PartnerInvoice]: "Partner Invoice",
  [EmailType.PreferredOffering]: "Preferred Offering",
  [EmailType.GenericOffering]: "Generic Offering",
  [EmailType.JourneyRejected]: "Journey Rejected",
  [EmailType.JourneyCancelled]: "Journey Cancelled",
  [EmailType.BookerBookingPlaced]: "Booking confirmation",
  [EmailType.BookerJourneyConfirmed]: "Journey confirmed by transfer company (voucher)",
  [EmailType.TravellerJourneyPlanned]: "Journey planned by transfer company",
  [EmailType.TransferCompanyAcceptedJourney]: "Transfer Company Accepted Journey",
  [EmailType.PendingJourneyDestinationManagerReminder]: "Pending Journey Destination Manager Reminder",
  [EmailType.CompletedJourneyTravellerSurvey]: "Completed Journey Traveller Survey",
};
